module.exports = __webpack_public_path__ + "static/media/accentoerbapura.b993d217.png";